export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      industries: "Branchen",
      about: "Über mich",
      contact: "Kontakt",
      reference: "Referenz",
      faq: "FAQ",
      blog: "Blog"
    },
    hero: {
      badge: "Webdesign & App-Entwicklung",
      title1: "Ihre Vision.",
      title2: "Unser Design.",
      subtitle: "Professionelle Websites und Apps, die Ihre Marke perfekt präsentieren. Modern. Einzigartig. Maßgeschneidert für Sie.",
      cta: "Projekt starten",
      ctaSecondary: "Lösungen entdecken",
      trust1: "Schnelle Umsetzung",
      trust2: "Moderne Technologien",
      trust3: "Persönlicher Support",
      scroll: "Mehr entdecken"
    },
    services: {
      badge: "Leistungen",
      title: "Was ich für Sie",
      titleHighlight: "erstelle",
      subtitle: "Maßgeschneiderte digitale Lösungen für Ihr Unternehmen",
      webdesign: "Webdesign",
      webdesignDesc: "Moderne, responsive Websites die Ihre Marke perfekt präsentieren und Besucher begeistern.",
      ecommerce: "E-Commerce",
      ecommerceDesc: "Professionelle Online-Shops mit nahtloser Benutzererfahrung und sicheren Zahlungslösungen.",
      webapps: "Web-Applikationen",
      webappsDesc: "Maßgeschneiderte Web-Apps die Ihre Geschäftsprozesse digitalisieren und optimieren.",
      mobile: "Mobile Apps",
      mobileDesc: "Native und plattformübergreifende Apps für iOS und Android, die Ihre Nutzer begeistern.",
      features: ["Responsive Design", "SEO-optimiert", "Schnelle Ladezeiten", "SSL-Verschlüsselung", "CMS-Integration"]
    },
    industries: {
      badge: "Branchen & Lösungen",
      title: "Für jede",
      titleHighlight: "Branche",
      titleEnd: "die passende Lösung",
      subtitle: "Egal ob Handwerker, Restaurant oder Startup – ich erstelle maßgeschneiderte Websites und Apps, die perfekt zu Ihrem Geschäft passen.",
      notListed: "Ihre Branche ist nicht dabei?",
      noProblem: "Kein Problem!",
      cta: "Individuelles Angebot anfragen"
    },
    reference: {
      badge: "Referenz-Projekt",
      title: "Ein Beispiel meiner",
      titleHighlight: "Arbeit",
      subtitle: "Diese Website wurde durch meinen Service erstellt",
      visitSite: "Website besuchen",
      createdWith: "Erstellt mit Design Vision"
    },
    about: {
      badge: "Über mich",
      title: "Hallo, ich bin",
      name: "Bastian",
      jobTitle: "Gründer & Webentwickler",
      skills: "Das biete ich an"
    },
    faq: {
      badge: "Häufige Fragen",
      title: "Haben Sie",
      titleHighlight: "Fragen?",
      subtitle: "Hier finden Sie Antworten auf die am häufigsten gestellten Fragen",
      items: [
        {
          question: "Wie lange dauert die Erstellung einer Website?",
          answer: "Je nach Umfang und Komplexität dauert ein Projekt in der Regel 1–4 Wochen. Eine einfache Landing Page kann schon in wenigen Tagen fertig sein, während ein kompletter Online-Shop mehr Zeit in Anspruch nimmt."
        },
        {
          question: "Was kostet eine Website?",
          answer: "Die Kosten variieren je nach Projektumfang. Eine einfache Website beginnt ab ca. 700€, während komplexere Projekte wie Online-Shops oder Web-Apps individuell kalkuliert werden. Kontaktieren Sie mich für ein kostenloses Angebot."
        },
        {
          question: "Kann ich meine Website selbst bearbeiten?",
          answer: "Ja! Auf Wunsch integriere ich ein benutzerfreundliches Content-Management-System (CMS), mit dem Sie Texte, Bilder und Inhalte selbstständig aktualisieren können – ohne Programmierkenntnisse."
        },
        {
          question: "Ist meine Website auch für Mobilgeräte optimiert?",
          answer: "Selbstverständlich! Alle meine Websites sind vollständig responsive und sehen auf Smartphones, Tablets und Desktop-Geräten gleichermaßen gut aus."
        },
        {
          question: "Bieten Sie auch Wartung und Support an?",
          answer: "Ja, ich biete verschiedene Wartungspakete an, die regelmäßige Updates, Sicherheitschecks und technischen Support umfassen. So bleibt Ihre Website immer aktuell und sicher."
        }
      ]
    },
    contact: {
      badge: "Kontakt",
      title: "Lassen Sie uns",
      titleHighlight: "zusammenarbeiten",
      description: "Haben Sie ein Projekt im Kopf? Ich freue mich darauf, von Ihnen zu hören und Ihre Ideen in die Realität umzusetzen.",
      email: "E-Mail",
      whatsapp: "WhatsApp",
      formTitle: "Nachricht senden",
      name: "Name",
      namePlaceholder: "Max Mustermann",
      emailPlaceholder: "max@beispiel.de",
      company: "Unternehmen",
      companyPlaceholder: "Ihre Firma GmbH",
      message: "Nachricht",
      messagePlaceholder: "Beschreiben Sie Ihr Projekt...",
      send: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.",
      error: "Es gab einen Fehler. Bitte versuchen Sie es erneut."
    },
    footer: {
      tagline: "Wir erschaffen digitale Erlebnisse, die Ihre Marke zum Strahlen bringen.",
      navigation: "Navigation",
      legal: "Rechtliches",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      privacy: "Datenschutz",
      madeIn: "Gestaltet in Deutschland"
    },
    cookie: {
      message: "Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu bieten.",
      accept: "Akzeptieren",
      decline: "Ablehnen"
    },
    blog: {
      badge: "Blog & Insights",
      title: "Neueste",
      titleHighlight: "Beiträge",
      subtitle: "Tipps, Trends und Einblicke aus der Welt des Webdesigns",
      readMore: "Weiterlesen",
      viewAll: "Alle Beiträge",
      pageTitle: "Blog",
      noPosts: "Noch keine Beiträge vorhanden.",
      notFound: "Beitrag nicht gefunden.",
      backToList: "Zurück zum Blog",
      share: "Teilen",
      ctaTitle: "Projekt im Kopf?",
      ctaText: "Lassen Sie uns gemeinsam Ihre Idee verwirklichen.",
      ctaButton: "Kontakt aufnehmen"
    },
    backToHome: "Zurück zur Startseite"
  },
  en: {
    nav: {
      services: "Services",
      industries: "Industries",
      about: "About",
      contact: "Contact",
      reference: "Reference",
      faq: "FAQ",
      blog: "Blog"
    },
    hero: {
      badge: "Web Design & App Development",
      title1: "Your Vision.",
      title2: "Our Design.",
      subtitle: "Professional websites and apps that perfectly present your brand. Modern. Unique. Tailored for you.",
      cta: "Start Project",
      ctaSecondary: "Discover Solutions",
      trust1: "Fast Delivery",
      trust2: "Modern Technologies",
      trust3: "Personal Support",
      scroll: "Discover More"
    },
    services: {
      badge: "Services",
      title: "What I",
      titleHighlight: "create",
      subtitle: "Custom digital solutions for your business",
      webdesign: "Web Design",
      webdesignDesc: "Modern, responsive websites that perfectly present your brand and delight visitors.",
      ecommerce: "E-Commerce",
      ecommerceDesc: "Professional online shops with seamless user experience and secure payment solutions.",
      webapps: "Web Applications",
      webappsDesc: "Custom web apps that digitize and optimize your business processes.",
      mobile: "Mobile Apps",
      mobileDesc: "Native and cross-platform apps for iOS and Android that delight your users.",
      features: ["Responsive Design", "SEO Optimized", "Fast Loading", "SSL Encryption", "CMS Integration"]
    },
    industries: {
      badge: "Industries & Solutions",
      title: "The right solution for",
      titleHighlight: "every",
      titleEnd: "industry",
      subtitle: "Whether craftsman, restaurant or startup – I create customized websites and apps that perfectly fit your business.",
      notListed: "Your industry not listed?",
      noProblem: "No problem!",
      cta: "Request Custom Quote"
    },
    reference: {
      badge: "Reference Project",
      title: "An example of my",
      titleHighlight: "work",
      subtitle: "This website was created through my service",
      visitSite: "Visit Website",
      createdWith: "Created with Design Vision"
    },
    about: {
      badge: "About Me",
      title: "Hello, I'm",
      name: "Bastian",
      jobTitle: "Founder & Web Developer",
      skills: "What I offer"
    },
    faq: {
      badge: "FAQ",
      title: "Have any",
      titleHighlight: "questions?",
      subtitle: "Here you'll find answers to the most frequently asked questions",
      items: [
        {
          question: "How long does it take to create a website?",
          answer: "Depending on the scope and complexity, a project usually takes 1–4 weeks. A simple landing page can be ready in just a few days, while a complete online shop takes more time."
        },
        {
          question: "How much does a website cost?",
          answer: "Costs vary depending on the project scope. A simple website starts from around 700€, while more complex projects like online shops or web apps are individually calculated. Contact me for a free quote."
        },
        {
          question: "Can I edit my website myself?",
          answer: "Yes! Upon request, I integrate a user-friendly Content Management System (CMS) that allows you to independently update texts, images and content – without any programming knowledge."
        },
        {
          question: "Is my website optimized for mobile devices?",
          answer: "Absolutely! All my websites are fully responsive and look equally great on smartphones, tablets and desktop devices."
        },
        {
          question: "Do you offer maintenance and support?",
          answer: "Yes, I offer various maintenance packages that include regular updates, security checks and technical support. This keeps your website always up to date and secure."
        }
      ]
    },
    contact: {
      badge: "Contact",
      title: "Let's",
      titleHighlight: "work together",
      description: "Have a project in mind? I look forward to hearing from you and turning your ideas into reality.",
      email: "Email",
      whatsapp: "WhatsApp",
      formTitle: "Send Message",
      name: "Name",
      namePlaceholder: "John Doe",
      emailPlaceholder: "john@example.com",
      company: "Company",
      companyPlaceholder: "Your Company Inc.",
      message: "Message",
      messagePlaceholder: "Describe your project...",
      send: "Send Message",
      sending: "Sending...",
      success: "Thank you! Your message was sent successfully.",
      error: "There was an error. Please try again."
    },
    footer: {
      tagline: "We create digital experiences that make your brand shine.",
      navigation: "Navigation",
      legal: "Legal",
      rights: "All rights reserved.",
      impressum: "Imprint",
      privacy: "Privacy Policy",
      madeIn: "Designed in Germany"
    },
    cookie: {
      message: "This website uses cookies to provide you with the best experience.",
      accept: "Accept",
      decline: "Decline"
    },
    blog: {
      badge: "Blog & Insights",
      title: "Latest",
      titleHighlight: "posts",
      subtitle: "Tips, trends and insights from the world of web design",
      readMore: "Read more",
      viewAll: "All posts",
      pageTitle: "Blog",
      noPosts: "No posts yet.",
      notFound: "Post not found.",
      backToList: "Back to blog",
      share: "Share",
      ctaTitle: "Got a project in mind?",
      ctaText: "Let's bring your idea to life together.",
      ctaButton: "Get in touch"
    },
    backToHome: "Back to homepage"
  },
  ar: {
    nav: {
      services: "الخدمات",
      industries: "القطاعات",
      about: "عني",
      contact: "اتصل بنا",
      reference: "مرجع",
      faq: "الأسئلة الشائعة",
      blog: "المدونة"
    },
    hero: {
      badge: "تصميم المواقع وتطوير التطبيقات",
      title1: "رؤيتك.",
      title2: "تصميمنا.",
      subtitle: "مواقع وتطبيقات احترافية تمثل علامتك التجارية بشكل مثالي. عصرية. فريدة. مصممة خصيصاً لك.",
      cta: "ابدأ مشروعك",
      ctaSecondary: "اكتشف الحلول",
      trust1: "تنفيذ سريع",
      trust2: "تقنيات حديثة",
      trust3: "دعم شخصي",
      scroll: "اكتشف المزيد"
    },
    services: {
      badge: "الخدمات",
      title: "ما",
      titleHighlight: "أقدمه",
      subtitle: "حلول رقمية مخصصة لعملك",
      webdesign: "تصميم المواقع",
      webdesignDesc: "مواقع عصرية ومتجاوبة تمثل علامتك التجارية بشكل مثالي وتبهر الزوار.",
      ecommerce: "التجارة الإلكترونية",
      ecommerceDesc: "متاجر إلكترونية احترافية بتجربة مستخدم سلسة وحلول دفع آمنة.",
      webapps: "تطبيقات الويب",
      webappsDesc: "تطبيقات ويب مخصصة ترقمن وتحسن عمليات عملك.",
      mobile: "تطبيقات الجوال",
      mobileDesc: "تطبيقات أصلية ومتعددة المنصات لـ iOS و Android تبهر مستخدميك.",
      features: ["تصميم متجاوب", "محسّن لمحركات البحث", "تحميل سريع", "تشفير SSL", "تكامل CMS"]
    },
    industries: {
      badge: "القطاعات والحلول",
      title: "الحل المناسب لكل",
      titleHighlight: "قطاع",
      titleEnd: "",
      subtitle: "سواء كنت حرفياً أو مطعماً أو شركة ناشئة - أقوم بإنشاء مواقع وتطبيقات مخصصة تناسب عملك تماماً.",
      notListed: "قطاعك غير مدرج؟",
      noProblem: "لا مشكلة!",
      cta: "اطلب عرض أسعار مخصص"
    },
    reference: {
      badge: "مشروع مرجعي",
      title: "مثال على",
      titleHighlight: "عملي",
      subtitle: "تم إنشاء هذا الموقع من خلال خدمتي",
      visitSite: "زيارة الموقع",
      createdWith: "تم إنشاؤه بواسطة Design Vision"
    },
    about: {
      badge: "عني",
      title: "مرحباً، أنا",
      name: "باستيان",
      jobTitle: "المؤسس ومطور الويب",
      skills: "ما أقدمه"
    },
    faq: {
      badge: "الأسئلة الشائعة",
      title: "هل لديك",
      titleHighlight: "أسئلة؟",
      subtitle: "هنا تجد إجابات على الأسئلة الأكثر شيوعاً",
      items: [
        {
          question: "كم يستغرق إنشاء موقع إلكتروني؟",
          answer: "حسب النطاق والتعقيد، يستغرق المشروع عادة من 1 إلى 4 أسابيع. يمكن أن تكون صفحة هبوط بسيطة جاهزة في بضعة أيام، بينما يحتاج متجر إلكتروني كامل إلى وقت أكثر."
        },
        {
          question: "كم يكلف إنشاء موقع إلكتروني؟",
          answer: "تختلف التكاليف حسب نطاق المشروع. يبدأ سعر الموقع البسيط من حوالي 700 يورو، بينما يتم حساب المشاريع الأكثر تعقيداً بشكل فردي. تواصل معي للحصول على عرض أسعار مجاني."
        },
        {
          question: "هل يمكنني تعديل موقعي بنفسي؟",
          answer: "نعم! بناءً على طلبك، أقوم بدمج نظام إدارة محتوى سهل الاستخدام يتيح لك تحديث النصوص والصور والمحتوى بشكل مستقل - دون الحاجة إلى معرفة برمجية."
        },
        {
          question: "هل موقعي محسّن للأجهزة المحمولة؟",
          answer: "بالتأكيد! جميع مواقعي متجاوبة بالكامل وتبدو رائعة على الهواتف الذكية والأجهزة اللوحية وأجهزة الكمبيوتر المكتبية."
        },
        {
          question: "هل تقدمون خدمات الصيانة والدعم؟",
          answer: "نعم، أقدم حزم صيانة متنوعة تشمل التحديثات المنتظمة وفحوصات الأمان والدعم الفني. هذا يبقي موقعك محدثاً وآمناً دائماً."
        }
      ]
    },
    contact: {
      badge: "اتصل بنا",
      title: "دعنا",
      titleHighlight: "نعمل معاً",
      description: "هل لديك مشروع في ذهنك؟ أتطلع لسماعك وتحويل أفكارك إلى واقع.",
      email: "البريد الإلكتروني",
      whatsapp: "واتساب",
      formTitle: "إرسال رسالة",
      name: "الاسم",
      namePlaceholder: "محمد أحمد",
      emailPlaceholder: "mohamed@example.com",
      company: "الشركة",
      companyPlaceholder: "شركتك",
      message: "الرسالة",
      messagePlaceholder: "صف مشروعك...",
      send: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      success: "شكراً لك! تم إرسال رسالتك بنجاح.",
      error: "حدث خطأ. يرجى المحاولة مرة أخرى."
    },
    footer: {
      tagline: "نصنع تجارب رقمية تجعل علامتك التجارية تتألق.",
      navigation: "التنقل",
      legal: "قانوني",
      rights: "جميع الحقوق محفوظة.",
      impressum: "البصمة القانونية",
      privacy: "سياسة الخصوصية",
      madeIn: "صُمم في ألمانيا"
    },
    cookie: {
      message: "يستخدم هذا الموقع ملفات تعريف الارتباط لتزويدك بأفضل تجربة.",
      accept: "قبول",
      decline: "رفض"
    },
    blog: {
      badge: "المدونة والأفكار",
      title: "أحدث",
      titleHighlight: "المقالات",
      subtitle: "نصائح واتجاهات ورؤى من عالم تصميم الويب",
      readMore: "اقرأ المزيد",
      viewAll: "جميع المقالات",
      pageTitle: "المدونة",
      noPosts: "لا توجد مقالات بعد.",
      notFound: "المقال غير موجود.",
      backToList: "العودة إلى المدونة",
      share: "مشاركة",
      ctaTitle: "لديك مشروع في ذهنك؟",
      ctaText: "دعنا نحقق فكرتك معاً.",
      ctaButton: "تواصل معنا"
    },
    backToHome: "العودة إلى الصفحة الرئيسية"
  }
};

// Industry translations
export const industryTranslations = {
  de: [
    { title: "Handwerker & Bau", description: "Professionelle Websites für Elektriker, Maler, Dachdecker und mehr", features: ["Online-Terminbuchung", "Projekt-Galerie", "Kundenbewertungen"] },
    { title: "Gastronomie", description: "Appetitliche Webauftritte für Restaurants, Cafés und Catering", features: ["Speisekarten", "Reservierungssystem", "Online-Bestellung"] },
    { title: "Fitness & Wellness", description: "Dynamische Websites für Fitnessstudios und Wellness-Anbieter", features: ["Kursplan-Integration", "Mitglieder-Portal", "Online-Buchung"] },
    { title: "Mode & Einzelhandel", description: "Stilvolle Online-Shops für Boutiquen und Einzelhändler", features: ["E-Commerce", "Produktkataloge", "Größenberater"] },
    { title: "Ärzte & Praxen", description: "Vertrauenswürdige Webpräsenzen für Arztpraxen und Therapeuten", features: ["Online-Terminbuchung", "Patientenportal", "Leistungsübersicht"] },
    { title: "Startups & Tech", description: "Innovative Websites und Apps für Tech-Startups", features: ["Landing Pages", "SaaS-Plattformen", "MVP-Entwicklung"] }
  ],
  en: [
    { title: "Craftsmen & Construction", description: "Professional websites for electricians, painters, roofers and more", features: ["Online Booking", "Project Gallery", "Customer Reviews"] },
    { title: "Gastronomy", description: "Appetizing websites for restaurants, cafés and catering", features: ["Menus", "Reservation System", "Online Ordering"] },
    { title: "Fitness & Wellness", description: "Dynamic websites for gyms and wellness providers", features: ["Schedule Integration", "Member Portal", "Online Booking"] },
    { title: "Fashion & Retail", description: "Stylish online shops for boutiques and retailers", features: ["E-Commerce", "Product Catalogs", "Size Guide"] },
    { title: "Doctors & Practices", description: "Trustworthy web presence for medical practices and therapists", features: ["Online Appointments", "Patient Portal", "Services Overview"] },
    { title: "Startups & Tech", description: "Innovative websites and apps for tech startups", features: ["Landing Pages", "SaaS Platforms", "MVP Development"] }
  ],
  ar: [
    { title: "الحرفيون والبناء", description: "مواقع احترافية للكهربائيين والدهانين والمزيد", features: ["حجز عبر الإنترنت", "معرض المشاريع", "تقييمات العملاء"] },
    { title: "المطاعم", description: "مواقع شهية للمطاعم والمقاهي والتموين", features: ["القوائم", "نظام الحجز", "الطلب عبر الإنترنت"] },
    { title: "اللياقة والعافية", description: "مواقع ديناميكية للصالات الرياضية ومقدمي العافية", features: ["تكامل الجدول", "بوابة الأعضاء", "الحجز عبر الإنترنت"] },
    { title: "الأزياء والتجزئة", description: "متاجر إلكترونية أنيقة للبوتيكات وتجار التجزئة", features: ["التجارة الإلكترونية", "كتالوجات المنتجات", "دليل المقاسات"] },
    { title: "الأطباء والعيادات", description: "حضور موثوق على الويب للعيادات والمعالجين", features: ["مواعيد عبر الإنترنت", "بوابة المرضى", "نظرة عامة على الخدمات"] },
    { title: "الشركات الناشئة والتقنية", description: "مواقع وتطبيقات مبتكرة للشركات الناشئة", features: ["صفحات الهبوط", "منصات SaaS", "تطوير MVP"] }
  ]
};

// About translations
export const aboutTranslations = {
  de: {
    bio: "Ich bin Bastian, der Kopf hinter Design Vision. Meine Mission ist es, Unternehmen dabei zu helfen, online sichtbar zu werden – mit Websites und Apps, die nicht nur gut aussehen, sondern auch funktionieren. Ich arbeite eng mit meinen Kunden zusammen, um ihre Ideen in digitale Realität umzusetzen.",
    skills: ["Webdesign", "E-Commerce", "Web-Apps", "Mobile Apps"]
  },
  en: {
    bio: "I'm Bastian, the mind behind Design Vision. My mission is to help businesses become visible online – with websites and apps that not only look great but also work perfectly. I work closely with my clients to turn their ideas into digital reality.",
    skills: ["Web Design", "E-Commerce", "Web Apps", "Mobile Apps"]
  },
  ar: {
    bio: "أنا باستيان، العقل وراء Design Vision. مهمتي هي مساعدة الشركات على الظهور عبر الإنترنت - بمواقع وتطبيقات لا تبدو رائعة فحسب، بل تعمل بشكل مثالي أيضاً. أعمل عن كثب مع عملائي لتحويل أفكارهم إلى واقع رقمي.",
    skills: ["تصميم المواقع", "التجارة الإلكترونية", "تطبيقات الويب", "تطبيقات الجوال"]
  }
};
